module.exports = __webpack_public_path__ + "img/interior-design-of-a-house-1571460.e040f15d.jpg";